import React, { Component } from 'react'
import _, { isEmpty, get } from 'lodash';
import ModalConfirmation from '../../../components/ModalConfirmation'
import asyncRoute from '../../../helpers/hoc/asyncRoute'
import Input from '../../../components/FormElements/Input'
import CheckboxGroup from '../../../components/FormElements/CheckboxGroup'
import { formFields, confirmationMessage, roleCompetetierList, GenderType, campaignObjective, adTypesData, SearchPlatform, displayPlatform, videoPlatform, formFieldsComp, successfullyMessage } from './constant';
import Select from '../../../components/FormElements/Select'
import SelectNew from '../../../components/FormElements/SelectNew'
import MultiSelect from '../../../components/FormElements/MultiSelect'
import { handleFieldError, handleError, initializeForm } from '../../../utils/form-validation'
// import ModalConfirmation from '../../components/ModalConfirmation'
import routes from '../../../routes'

import { Modal } from 'semantic-ui-react';
import { Link } from 'react-router-dom'
import { geoData } from '../../../constants/enum';

import { getAgeListAction, getCategoryAction, getSUbCategoryAction, postMediaCreateAction, getGeoLocationAction, getFacebookAccountsAction,getGeoLocationFacebookAction,getLanguageListAction } from '../../../actions'
// import { getAgeListAction, getCategoryAction, getSUbCategoryAction, getMediaPlanListAction } from '../../../actions'

import { equalTo, sortArray } from '../../../selectors';
import { connect } from 'react-redux'
import { platform } from 'chart.js';
import { CostExplorer } from 'aws-sdk';
// import { endPoints } from '../../../constants/configuration/configuration_stage';
import { endPoints } from '../../../constants/configuration/configuration_prod';
import client from '../../../utils/client';
import { log } from 'async';
import ToastModal from "../../../components/ToastModal";
import { demoTenantIds } from '../../../constants/configuration';
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));
const Card = asyncRoute(() => import('../../../components/Card'));


class index extends Component {
    constructor(props) {
        // console.log(props,"props form")
        super(props);
        this.state = {
            form: {},
            touched: {},
            errors: {},
            editMode: false,
            submited: false,
            confirmationOpen: false,
            confirmationInfo: '',
            openLocation: false,
            openBulkPincodeSearch: false,
            geoList: [],
            geoInput: '',
            selectedInExList: [],
            geoApiCall: true,
            getPayloadGeoLocation: [],
            competitors: [
                { name: '', url: '', errors: {}, touched: {} }
            ],
            platforms: [],
            adType: [],
            ages: [],
            categoryData: [],
            subCategoryData: [],
            getCategoryId: null,
            getAgepayloadFormat: [],
            getGenderFormat: [{ value: '', inex: '' }],
            displayPlatformData: [
                {
                    "key": "1",
                    "value": "Google Adwords",
                    "checked": true,
                    "disabled": false,
                    "parentIndex": null
                },
                {
                    "key": "2",
                    "value": "Facebook",
                    "checked": true,
                    "disabled": false,
                    "parentIndex": null
                },
                {
                    "key": "3",
                    "value": "Programmatic (ION & DV360)",
                    "checked": true,
                    "disabled": false,
                    "parentIndex": 1
                }
            ],
            enableToast: false,
            toastStatus: "",
            toastMsg: "",
            confirmationMsg: "",
            googleSearchLocation: false,
            facebookSearchLocation: false,
            selectedGoogleGeoList: [],
            selectedFacebookGeoList: [],
            specificLocation: [],
            getPayloadFacebookLocation: [],
            facebookAccountsData: [],
            selectedGeoPlatForm:-1,
            enableDeleteToast:false,
            tmpselectedGoogleGeoList:[],
            tmpselectedFacebookGeoList:[],

        };

        adTypesData.forEach(item => {
            item.checked = false;
        })

        displayPlatform.forEach(item => {
            item.checked = false;
        })
    }

    async componentWillMount() {
        const { tenantId, authToken, userId, getAgeListAction, configurationList } = this.props;
        const currency = get(configurationList.find(currency => currency.attrName === 'CURRENCY'), 'attributeValues', []);
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (isEmpty(isAuthenticated)) {
            const { history } = this.props;
            history.push(routes.preSignIn);
        }

        const { form, errors } = initializeForm(formFields);
        // form.adType = adTypesData;
        // form.platform = displayPlatform;
        form.gender = "All";
        form.campaignObjective = 'WebsiteTraffic';
        form.budget = 500;
        form.adType = [
            {
                "key": "1",
                "value": "Search",
                "checked": true,
                "inCludedIn": [
                    "Google Adwords"
                ]
            },
            {
                "key": "2",
                "value": "Display",
                "checked": true,
                "inCludedIn": [
                    "Google Adwords",
                    "Facebook",
                    "Programmatic (ION & DV360)"
                ]
            },
            {
                "key": "3",
                "value": "Video",
                "checked": true,
                "inCludedIn": [
                    "Facebook"
                ]
            }
        ];
        form.platform = [
            {
                "key": "1",
                "value": "Google Adwords",
                "checked": true,
                "disabled": false,
                "parentIndex": null
            },
            {
                "key": "2",
                "value": "Facebook",
                "checked": true,
                "disabled": false,
                "parentIndex": null
            },
            {
                "key": "3",
                "value": "Programmatic (ION & DV360)",
                "checked": true,
                "disabled": false,
                "parentIndex": 1
            }
        ]
        this.setState({ form }, () => {

        });
        await this.ageApi();
        await this.categoryApiFunction();
        await this.languageApiFunction();
        await this.facebookAccountsFunction();
        // await this.subCategoryApiFunction();

    }

    languageApiFunction = async () => {
        const { form } = this.state;
        const { tenantId, authToken, userId, getLanguageListAction, configurationList } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getLanguageListAction({ tenantId, authToken, userId });
        if (status == "Success") {
            const languageListDropdownData = responseList.map((item, index) => {
                return { text: item.languageConstant.name, id: item.languageConstant.resourceName };
            });
            
            // Find the default language, in this case, "English"
            const defaultLanguage = languageListDropdownData.find(language => language.text === "English");

            // Set the default language in the form object
            form.language = defaultLanguage ? defaultLanguage.id : '';

            this.setState({ languageData: languageListDropdownData });
        }
    }


    ageApi = async () => {
        const { tenantId, authToken, userId, getAgeListAction, configurationList } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getAgeListAction({ tenantId, authToken, userId });
        if (status == "success") {
            // console.log(responseList, "outputMedia")

            const { form } = this.state;
            const agesListDropdownData = responseList.map((item, index) => {
                return { text: item.value };
            });

            form.age = agesListDropdownData.map((dataAge)=>dataAge.text);

            this.setState({ ages: agesListDropdownData });
        }

    }


    facebookAccountsFunction = async () => {
        const { tenantId, authToken, userId, getFacebookAccountsAction, configurationList } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getFacebookAccountsAction({ tenantId, authToken, userId });
        if (status == "Success") {

            // const dataFacebook = responseList.map((item, index) => {
            //     return { text: item.id };
            // });
            this.setState({ facebookAccountsData: responseList })

        }

    }

    categoryApiFunction = async () => {
        const { tenantId, authToken, userId, getCategoryAction, configurationList } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getCategoryAction({ tenantId, authToken, userId });
        if (status == "success") {
            // console.log(responseList, "cat")
            const categoryListDropdownData = responseList.map((item, index) => {
                return { text: item.value, categoryID: item.id };
            });
            this.setState({ categoryData: categoryListDropdownData });
        }
    }

    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };

    selectLocation = (e) => {
        e.preventDefault();
        // const { seletedPlatform } = this.state;
        const { seletedPlatform, selectedFacebookGeoList, selectedGoogleGeoList } = this.state;
        let displayPlatformData = [
            { key: '1', value: 'Google Adwords', checked: true, disabled: false, parentIndex: null },
            { key: '2', value: 'Facebook', checked: true, disabled: false, parentIndex: null },
            { key: '3', value: 'Programmatic (ION & DV360)', checked: true, disabled: false, parentIndex: 1 },
        ]
        // console.log("displayPlatformData",displayPlatformData)

        // this.setState({ openLocation: !this.state.openLocation, geoList: [], geoInput: '', googleSearchLocation: false, facebookSearchLocation: false, selectedGeoPlatForm:-1  });

        let displayPLayCheckDataPLatform = displayPlatformData.filter((dataPLat)=>dataPLat.checked).map((dataPlat)=>dataPlat.value);


        let showCombinePlat = [];
        let selPlatform =''
        if(displayPLayCheckDataPLatform.includes('Google Adwords')){
            showCombinePlat.push('Google Adwords');
        }
        if(displayPLayCheckDataPLatform.includes('Programmatic (ION & DV360)')){
            showCombinePlat.push('Programmatic (ION & DV360)');

        }
         displayPLayCheckDataPLatform.forEach((dataPlat)=>{
            if(!dataPlat.includes('Google Adwords') && !dataPlat.includes('Programmatic (ION & DV360)')){
                showCombinePlat.push(dataPlat);
            }
          
        })
        if(displayPLayCheckDataPLatform.includes('Google Adwords') && displayPLayCheckDataPLatform.includes('Programmatic (ION & DV360)')){
            showCombinePlat.push('Google Adwords & Programmatic (ION & DV360)');
            showCombinePlat =showCombinePlat.filter(ele=> ele !== "Google Adwords")
            showCombinePlat =showCombinePlat.filter(ele=> ele !== "Programmatic (ION & DV360)")

        }

        let clonedFbSelectedList = _.cloneDeep(selectedFacebookGeoList);
        let clonedGoogleSelectedList = _.cloneDeep(selectedGoogleGeoList)

        // this.setState({ openLocation: !this.state.openLocation, geoList: [], geoInput: '', googleSearchLocation: false, facebookSearchLocation: false, selectedGeoPlatForm: -1, tmpselectedFacebookGeoList: clonedFbSelectedList, tmpselectedGoogleGeoList: clonedGoogleSelectedList });
        
    if(showCombinePlat[0].includes('Google Adwords') || showCombinePlat[0].includes('DV360')){
        this.setState({ openLocation: !this.state.openLocation, geoList: [], geoInput: '', googleSearchLocation: true, facebookSearchLocation: false, selectedGeoPlatForm: showCombinePlat[0],tmpselectedFacebookGeoList:clonedFbSelectedList,tmpselectedGoogleGeoList:clonedGoogleSelectedList });
        }
        else if(showCombinePlat[0].includes('Facebook')){
          this.setState({ openLocation: !this.state.openLocation, geoList: [], geoInput: '', googleSearchLocation: false, facebookSearchLocation: true, selectedGeoPlatForm: showCombinePlat[0],tmpselectedFacebookGeoList:clonedFbSelectedList,tmpselectedGoogleGeoList:clonedGoogleSelectedList });
        }

    }

    openBulkPincode = (flag) => {
        this.setState({ openBulkPincodeSearch: flag, geoList: [], geoInput: '' });
    };

    handleChange = (e) => {
        const adData = [];
        const platData = []
        const ageFormat = []
        const genderFormat = []
        let { form, adTypeDataList, platformDataList, categoryData, displayPlatformData} = this.state;
        const { countryList, getStateList, getCityList } = this.props
        let newOptionToSet = _.cloneDeep(displayPlatform);

        const categoryValue = e.target.value;
        const filterCategory = categoryData.filter(cat => {
            return cat.text === categoryValue
        })


        if (filterCategory.length > 0) {
            filterCategory.map(data => {
                this.subCategoryApiFunction(data.categoryID)
            })

        }

        let { value, name } = e.target;

        // if(name == "adType"){

        //     if (form.adType.length > 0) {
        //         form.adType.forEach(item => {
        //             if (item.key == 1 && item.checked === false) {
        //                 this.setState({ displayPlatformData: displayPlatform })
        //             }
        //             else if (item.key == 2 && item.checked === false) {
        //                 this.setState({ displayPlatformData: displayPlatform })
        //             } else if (item.key == 3 && item.checked === false) {

        //                 var filterPlatform = displayPlatform.filter(platform => platform.key == item.key);
        //                 // displayPlatform.forEach(platform => {
        //                 //     if (platform.key == 2) {
        //                 //         filterPlatform.push(platform);
        //                 //     }
        //                 // })
        //                 this.setState({ displayPlatformData: displayPlatform })
        //             }
        //         })
        //     }
        // }


        form[name] = value;
        this.setState({ form });

        if (form.adType != undefined) {
            let adType = form.adType.filter((e) => {
                return e.checked === true;
            });

            // console.log("adType", adType);

            if (adType.length > 0) {
                adType.forEach(item => {
                    if (item.key == 1 && item.checked === true) {
                        var filterPlatform = displayPlatform.filter(platform => platform.key == item.key);
                        this.setState({ displayPlatformData: filterPlatform })
                    }
                    else if (item.key == 2 && item.checked === true) {
                        this.setState({ displayPlatformData: displayPlatform })
                    } else if (item.key == 3 && item.checked === true) {

                        var filterPlatform = displayPlatform.filter(platform => platform.key == item.key);
                        displayPlatform.forEach(platform => {
                            if (platform.key == 2) {
                                filterPlatform.push(platform);
                            }
                        })
                        this.setState({ displayPlatformData: filterPlatform })
                    }
                })

                if (adType.length > 1) {
                    this.setState({ displayPlatformData: displayPlatform })
                }
            }    else {
                let adTypeFalse = form.adType.filter((e) => {
                    return e.checked === false;
                });

                adTypeFalse.forEach(item => {
                    if (item.key == 1 && item.checked === false)
                        this.setState({ displayPlatformData: [] })

                    else if (item.key == 2 && item.checked === false)
                        this.setState({ displayPlatformData: [] })

                    else if (item.key == 3 && item.checked === false)
                        this.setState({ displayPlatformData: [] })
                })
            }



        }
        if (form.adType != undefined) {
            // this.setState({ adTypeDataList: adType });
            // console.log("adType", adTypeDataList);

            form.adType.map((e) => {
                if (e.checked === true) {
                    adData.push(e.value)
                }
            })
            // console.log(adData,"data")
            this.setState({ adType: adData });
        }

        if (form.platform != undefined) {
            let platform = form.platform.filter((e) => {
                return e.checked === true;
            });
            platform.map((e) => {
                platData.push(e.value);

            })

            

            if(form.adType){
                let adTypeFalse = form.adType.filter((e) => {
                    return e.checked === false;
                });

                let dataPLatVAlue =  adTypeFalse.map((dataPlat)=>dataPlat.value);


                if(dataPLatVAlue && dataPLatVAlue.length > 0){
                    if(!dataPLatVAlue.includes('Search') && !dataPLatVAlue.includes('Display')){

                        newOptionToSet.forEach((dataPlat,index)=>{
                            if(dataPlat.value == "Google Adwords"){
                                newOptionToSet[index].checked = false;
                            }
                        })
                        // platData[] = false;
            
                    }
    
                    if(!dataPLatVAlue.includes('Display') && !dataPLatVAlue.includes('Video')){

                        newOptionToSet.forEach((dataPlat,index)=>{
                            if(dataPlat.value == "Facebook" || dataPlat.value == "Programmatic (ION & DV360)"){
                                newOptionToSet[index].checked = false;
                            }
                        })
                        // platData[] = false;
                    }
                }
            }

            this.setState({ platforms: platData,displayPlatform:newOptionToSet })
        }

        if (name = 'age') {
            form.age != undefined && form.age.map((e) => {
                // console.log(e,"e")
                ageFormat.push({ value: e, inex: 1 })
            })
            this.setState({ getAgepayloadFormat: ageFormat })
        }

        this.setState({ getGenderFormat: [{ value: form.gender, inex: 1 }] })


        if (name === 'country') {
            form.countryCode = [];
            value.forEach(b => {
                const country = countryList.find(a => equalTo(a.id, b));
                if (country) {
                    form.countryCode.push(country.countryCode);
                }
            });
            // form['countryCode'] = country ? country.countryCode : null;
        }

        if (name === 'state') {
            form.stateCode = [];
            value.forEach(b => {
                const state = getStateList.find(a => equalTo(a.id, b));
                if (state) {
                    form.stateCode.push(state.stateCode);
                }
            });
        }


        if (name === 'city') {
            form.cityCode = [];
            value.forEach(b => {
                const city = getCityList.find(a => equalTo(a.id, b));
                if (city) {
                    form.cityCode.push(city.id);
                }
            });
        }
    };

    subCategoryApiFunction = async (cateID) => {
        // console.log("new a", cateID);
        const { tenantId, authToken, userId, getSUbCategoryAction, configurationList } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getSUbCategoryAction({ tenantId, authToken, cateID, userId });
        if (status == "success") {
            // console.log(responseList, "subCat")
            const subCategoryListDropdownData = responseList.map((item, index) => {
                return { text: item.value, categoryID: item.id };
            });
            this.setState({ subCategoryData: subCategoryListDropdownData });
        }

    }


    getDataLocationFacebook(dataArray) {
        let dataForGeoList = dataArray.map((data) => {
            let name = data.name ? (data.name + ', ') : '';
            let type = data.type ? (data.type + ', ') : '';
            let region = data.region ? (data.region + ', ') : '';
            let country = data.country_name ? data.country_name : '';

            return {
                ...data,
                value: name + type + region + country
            }
        })

        return dataForGeoList;
    }

    handleCountryFilter = async (query) => {
        const { tenantId, authToken, userId, getGeoLocationFacebookAction } = this.props;
        const { geoInput } = this.state;
        if (!query || !query.length || geoInput.length <= 2) {
          this.setState({ options: [] });
          return;
        }
        try {
          let querySearch = `fb/geo?search=${query}&type=country`;
          const data = await getGeoLocationFacebookAction({ tenantId, authToken, userId, query: querySearch })
          // console.log(data);
          if (data && data.responseCode && data.responseCode.status === "Success") {
            // this.setState({ optionsCountry: data.responseList });
            let dataArrange = this.getDataLocationFacebook(data.response.data)
            this.setState({ geoList: [...this.state.geoList, ...dataArrange] });
          }
        } catch (error) {
          // get axios errors from error.response
          // console.log(error);
          throw error;
        }
        this.handleRegionFilter(query);
      }


      handleRegionFilter = async (query) => {
        const { tenantId, authToken, userId, getGeoLocationFacebookAction } = this.props;
        if (!query || !query.length) {
          this.setState({ options: [] });
          return;
        }
        try {
          let querySearch = `fb/geo?search=${query}&type=region`;
          const data = await getGeoLocationFacebookAction({ tenantId, authToken, userId, query: querySearch })
          //   console.log(data,"state");
          if (data && data.responseCode && data.responseCode.status === "Success") {
            // this.setState({ optionsState: data.responseList });
            let dataArrange = this.getDataLocationFacebook(data.response.data)
            this.setState({ geoList: [...this.state.geoList, ...dataArrange] });
          }
        } catch (error) {
          // get axios errors from error.response
          console.log(error);
          throw error;
        }
        this.handleCityFilter(query);
      };


      handleCityFilter = async (query) => {
        const { tenantId, authToken, userId, getGeoLocationFacebookAction } = this.props;
        if (!query || !query.length) {
          this.setState({ options: [] });
          return;
        }
        try {
          let querySearch = `fb/geo?search=${query}&type=city`;
          const data = await getGeoLocationFacebookAction({ tenantId, authToken, userId, query: querySearch })
          //   console.log(data,"city")
          if (data && data.responseCode && data.responseCode.status === "Success") {
            let dataArrange = this.getDataLocationFacebook(data.response.data)
            this.setState({ geoList: [...this.state.geoList, ...dataArrange] });
          }
        } catch (error) {
          // get axios errors from error.response
          console.log(error);
          throw error;
        }
        this.handlePincodeFilter(query);
      };
    
      handlePincodeFilter = async (query) => {
        const { tenantId, authToken, userId, getGeoLocationFacebookAction } = this.props;
        if (!query || !query.length) {
          this.setState({ options: [] });
          return;
        }
        try {
          let querySearch = `fb/geo?search=${query}&type=zip`;
          const data = await getGeoLocationFacebookAction({ tenantId, authToken, userId, query: querySearch })
          if (data && data.responseCode && data.responseCode.status === "Success" && data.response) {
            // this.setState({ optionsPincode: data.responseList });
            let dataArrange = this.getDataLocationFacebook(data.response.data)
            this.setState({ geoList: [...this.state.geoList, ...dataArrange], geoApiCall: false });
          }
        } catch (error) {
          // get axios errors from error.response
          console.log(error);
          this.setState({ geoApiCall: false });
          throw error;
        }
      };


          // handleCountryFilter = async (query) => {
    //     const { tenantId, authToken, userId } = this.props;
    //     if (!query || !query.length) {
    //         this.setState({ options: [] });
    //         return;
    //     }
    //     try {
    //         const { data } = await client().get(`fb/geo?search=${query}&type=country`, {
    //             headers: {
    //                 common: {
    //                     'tai_tenant': parseInt(tenantId),
    //                     'tai_token': authToken,
    //                     'tai_user': userId,
    //                 }
    //             }
    //         });
    //         if (data && data.responseCode && data.responseCode.status === "Success") {
    //             // this.setState({ optionsCountry: data.responseList });
    //             // this.setState({ geoList: [...this.state.geoList, ...data.response.data] });
    //             let dataArrange = this.getDataLocationFacebook(data.response.data)
    //             this.setState({ geoList: [...this.state.geoList, ...dataArrange] });
    //         }
    //     } catch (error) {
    //         // get axios errors from error.response
    //         // console.log(error);
    //         throw error;
    //     }
    //     this.handleRegionFilter(query);
    // };

    // handleRegionFilter = async (query) => {
    //     const { tenantId, authToken, userId } = this.props;
    //     if (!query || !query.length) {
    //         this.setState({ options: [] });
    //         return;
    //     }
    //     try {
    //         const { data } = await client().get(`fb/geo?search=${query}&type=region`, {
    //             headers: {
    //                 common: {
    //                     'tai_tenant': parseInt(tenantId),
    //                     'tai_token': authToken,
    //                     'tai_user': userId,
    //                 }
    //             }
    //         });
    //         //   console.log(data,"state");
    //         if (data && data.responseCode && data.responseCode.status === "Success") {
    //             // this.setState({ optionsState: data.responseList });
    //             // this.setState({ geoList: [...this.state.geoList, ...data.response.data] });
    //             let dataArrange = this.getDataLocationFacebook(data.response.data)
    //             this.setState({ geoList: [...this.state.geoList, ...dataArrange] });
    //         }
    //     } catch (error) {
    //         // get axios errors from error.response
    //         console.log(error);
    //         throw error;
    //     }
    //     this.handleCityFilter(query);
    // };

    // handleCityFilter = async (query) => {
    //     const { tenantId, authToken, userId } = this.props;
    //     if (!query || !query.length) {
    //         this.setState({ options: [] });
    //         return;
    //     }
    //     try {
    //         const { data } = await client().get(`fb/geo?search=${query}&type=city`, {
    //             headers: {
    //                 common: {
    //                     'tai_tenant': parseInt(tenantId),
    //                     'tai_token': authToken,
    //                     'tai_user': userId,
    //                 }
    //             }
    //         });
    //         //   console.log(data,"city")
    //         if (data && data.responseCode && data.responseCode.status === "Success") {
    //             // this.setState({ optionsCity: data.responseList });
    //             // this.setState({ geoList: [...this.state.geoList, ...data.response.data] });
    //             let dataArrange = this.getDataLocationFacebook(data.response.data)
    //             this.setState({ geoList: [...this.state.geoList, ...dataArrange] });
    //         }
    //     } catch (error) {
    //         // get axios errors from error.response
    //         console.log(error);
    //         throw error;
    //     }
    //     this.handlePincodeFilter(query);
    // };

    // handlePincodeFilter = async (query) => {
    //     const { tenantId, authToken, userId } = this.props;
    //     if (!query || !query.length) {
    //         this.setState({ options: [] });
    //         return;
    //     }
    //     try {
    //         const { data } = await client().get(`fb/geo?search=${query}&type=zip`, {
    //             headers: {
    //                 common: {
    //                     'tai_tenant': parseInt(tenantId),
    //                     'tai_token': authToken,
    //                     'tai_user': userId,
    //                 }
    //             }
    //         }).then((data) => {
    //             this.setState({ geoApiCall: false });
    //             return data;
    //         });
    //         if (data && data.responseCode && data.responseCode.status === "Success") {
    //             // this.setState({ optionsPincode: data.responseList });
    //             // this.setState({ geoList: [...this.state.geoList, ...data.response.data] });
    //             let dataArrange = this.getDataLocationFacebook(data.response.data)
    //             this.setState({ geoList: [...this.state.geoList, ...dataArrange] });
    //         }
    //     } catch (error) {
    //         // get axios errors from error.response
    //         console.log(error);
    //         this.setState({ geoApiCall: false });
    //         throw error;
    //     }
    // };

    handleTouch = (e) => {
        let { touched, form, errors } = this.state;
        let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };

    confirmationCallBack = (success, info) => {
        const { confirmationOpen } = this.state;
        if (success && info.action.type === 'Confirmation') {
            this.setState({ confirmationOpen: !confirmationOpen }, async () => {
                await this.handleSave();
            });
        } else if (info.action.type === 'Success') {
            this.setState({ confirmationOpen: !confirmationOpen }, () => {
                const { history } = this.props;
                history.push('/' + routes.mainRoute + '/' + routes.containers.mediaPlan);
            });
            // return;
        }


        this.setState({ confirmationOpen: false });
    };

    handleGeoApi = (e) => {
        const { value } = e.target;
        const { facebookSearchLocation, googleSearchLocation } = this.state;
        this.setState({ geoList: [], geoInput: value, geoApiCall: !!value.length });
        if (value.length > 2) {
            this.debounceSearch(() => {
                // this.setState({ geoApiCall: true }, ())
                if (googleSearchLocation) {
                    this.handleGoogleLocation(value);
                }
                else if (facebookSearchLocation) {
                    this.handleCountryFilter(value);
                }
            }, 1500);
        }
        else {
            this.setState({ geoList: [], geoApiCall: false })
          }
    };
    debounceSearch = (func, time) => {
        clearTimeout(this.searchInputTimeout);
        this.searchInputTimeout = setTimeout(func, time);
    };


    handleGoogleLocation = async (query) => {
        const { getGeoLocationAction, tenantId, authToken, userId } = this.props;
        const { geoInput } = this.state;

        if(geoInput.length > 2){

        const { responseCode: { status = "" }, responseList } = await getGeoLocationAction({ tenantId, authToken, userId, query });
        if (status == "Success") {
            // this.setState({})
            // var formatLocationData = responseList.map(item => {
            //   return { label: item.value, value: item.key, region: item.type }
            // })
            this.setState({ geoList: responseList, googleLocationClicked: true, geoApiCall: false })
            }
        }
    }

    handleSpecificLocation = (platform, index) => {
        if (platform.includes("Google Adwords & Programmatic (ION & DV360)") || platform.includes("Google Adwords") || platform.includes("Programmatic (ION & DV360)")) {
            this.setState({ googleSearchLocation: true, facebookSearchLocation: false, geoInput: '', geoList: [], selectedGeoPlatForm:platform  })
        }
        else if (platform.toLowerCase() == "facebook") {
            this.setState({ facebookSearchLocation: true, googleSearchLocation: false, geoInput: '', geoList: [], selectedGeoPlatForm:platform })
        }
    }


    handleSelectLocation = (e, item, inex) => {
        // const { selectedGoogleGeoList, selectedFacebookGeoList, googleSearchLocation, facebookSearchLocation } = this.state;
        const { selectedGoogleGeoList,tmpselectedGoogleGeoList, selectedFacebookGeoList,tmpselectedFacebookGeoList, googleSearchLocation, facebookSearchLocation } = this.state;
        if (googleSearchLocation) {
            // const isExist = selectedGoogleGeoList.findIndex(data => item.key == data.id);
            const isExist = tmpselectedGoogleGeoList.findIndex(data => item.key == data.id);

            if (isExist !== -1) {
                // selectedGoogleGeoList.splice(isExist, 1);
                tmpselectedGoogleGeoList.splice(isExist, 1);
                if (e.target.nextElementSibling) e.target.nextElementSibling.style.color = '#808080';
                if (e.target.previousElementSibling) e.target.previousElementSibling.style.color = '#808080';
            }
            // selectedGoogleGeoList.push({ id: item.key, value: item.value, type: item.type, inex })
            tmpselectedGoogleGeoList.push({ id: item.key, value: item.value, type: item.type, inex })
            e.target.style.color = !!inex ? 'rgb(0, 128, 0)' : 'rgb(255, 0, 0)';


            // this.setState({ selectedGoogleGeoList })
            this.setState({ tmpselectedGoogleGeoList })
        }
        else if (facebookSearchLocation) {
            // const isExist = selectedFacebookGeoList.findIndex(data => item.key == data.id);
            const isExist = tmpselectedFacebookGeoList.findIndex(data => item.key == data.id);

            if (isExist !== -1) {
                // selectedFacebookGeoList.splice(isExist, 1);
                tmpselectedFacebookGeoList.splice(isExist, 1);
                if (e.target.nextElementSibling) e.target.nextElementSibling.style.color = '#808080';
                if (e.target.previousElementSibling) e.target.previousElementSibling.style.color = '#808080';
            }
            // selectedFacebookGeoList.push({ ...item, id: item.key, inex })
            tmpselectedFacebookGeoList.push({ ...item, id: item.key, inex })
            e.target.style.color = !!inex ? 'rgb(0, 128, 0)' : 'rgb(255, 0, 0)';
            // this.setState({ selectedFacebookGeoList })
            this.setState({ tmpselectedFacebookGeoList })
        }
    }



    handleAddClick = () => {
        this.setState({ competitors: [...this.state.competitors, { name: "", url: "", errors: {}, touched: {} }] });
    };

    handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...this.state.competitors];
        list[index][name] = value;
        this.setState({ competitors: list });
    }

    handleRemoveClick = index => {
        const { confirmationRemove } = this.state;
        const list = [...this.state.competitors];
        list.splice(index, 1);
        this.setState({ competitors: list, confirmationRemove: !confirmationRemove, });
    };

    handleTouchCompetitive = (e, index) => {
        let { competitors } = this.state;
        let { error } = handleFieldError(competitors[index][e.target.name], roleCompetetierList[e.target.name]);
        competitors[index].errors[e.target.name] = error;
        competitors[index].touched[e.target.name] = true;
        this.setState({ competitors });
    };

    toggleModalRemove = (id, e) => {
            this.setState({ RemoveCompetitors: id,enableDeleteToast: true, confirmationMsg: "Are you sure to delete?", toastMsg: "", toastStatus: "" });
        }


    confirmationCallbackDelete = (id) => {
        let { RemoveCompetitors } = this.state;
        this.setState({ enableDeleteToast: false }, () => {
            this.handleRemoveClick(RemoveCompetitors);
        });
    }

    handleToastDelete = (status) => {
        const { match, history } = this.props;
        this.setState({ enableDeleteToast: status });
    }

    renderCompetitors = () => {
        let formdata = this.state.competitors;
        const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode } = this.state;
        let competitorsValue = formdata.map((competitorsList, index) => {
            return (
                <>

                    <div className='row col-md-12  mt-3 cardStyleMediaPlan'>
                        {
                            index > 0 &&
                            <span className='d-block d-md-none' style={{
                                backgroundColor: '#f70000',
                                position: 'absolute',
                                top: -5,
                                right: -8,
                                width: 30,
                                paddingLeft: 8,
                                paddingTop: 3,
                                borderRadius: '50%',
                                height: 30,
                                cursor: 'pointer',
                                color: '#FFF'

                            }}
                                onClick={() => this.handleRemoveClick(index)}>
                                <i className='mdi mdi-close'></i>
                            </span>
                        }
                        <div className='col-md-5'>
                            <Input
                                onChange={(e) => this.handleInputChange(e, index)}
                                onBlur={(e) => this.handleTouchCompetitive(e, index)}
                                value={competitorsList.name}
                                setting={roleCompetetierList[roleCompetetierList.name.key]}
                                error={competitorsList.errors[roleCompetetierList.name.key]}
                                submited={submited}
                                touched={competitorsList.touched[roleCompetetierList.name.key]}
                            />
                        </div>

                        <div className='col-md-6'>
                            <Input
                                onChange={(e) => this.handleInputChange(e, index)}
                                onBlur={(e) => this.handleTouchCompetitive(e, index)}
                                value={competitorsList.url}
                                setting={roleCompetetierList[roleCompetetierList.url.key]}
                                error={competitorsList.errors[roleCompetetierList.url.key]}
                                submited={submited}
                                touched={competitorsList.touched[roleCompetetierList.url.key]}
                            />
                        </div>

                        {
                            index > 0 ?
                                <button className="btn btn-danger col-md-1 d-none d-md-block" style={{ height: '30px', marginTop: '36px', maxWidth: 45 }} onClick={() => this.toggleModalRemove(index)}><i className='mdi mdi-delete'></i></button> : ""
                        }
                    </div>
                </>
            )
        })
        return competitorsValue;
    };

    onDoneGeoChanges = () => {
        const { selectedInExList, selectedGeoList } = this.state;
        let arr = _.unionBy(selectedInExList, selectedGeoList, 'catGeoId');
        const selectedList = arr.map((item) => ({ ...item }));
        // const selectedList = arr.map((item) =>console.log(item,"please chek"))
        this.setState({ geoInput: '', geoList: [], selectedGeoList: selectedList, selectedInExList: [] });
        this.handleChange({ target: 'geoFilter', value: arr });
    };

    removeGeoLocation = (id) => {
        // const { selectedGoogleGeoList, selectedFacebookGeoList, googleSearchLocation, facebookSearchLocation } = this.state;
        const { selectedGoogleGeoList, selectedFacebookGeoList,tmpselectedGoogleGeoList, tmpselectedFacebookGeoList, googleSearchLocation, facebookSearchLocation } = this.state;
        if (googleSearchLocation) {
            // this.setState({ selectedGoogleGeoList: selectedGoogleGeoList.filter(item => item.id != id) });
            this.setState({ tmpselectedGoogleGeoList: tmpselectedGoogleGeoList.filter(item => item.id != id) });
        }
        else if (facebookSearchLocation) {
            // this.setState({ selectedFacebookGeoList: selectedFacebookGeoList.filter(item => item.id != id) });
            this.setState({ tmpselectedFacebookGeoList: tmpselectedFacebookGeoList.filter(item => item.id != id)}); 
        }
    };


    handleSelectedLocation = (e, data, inEx) => {
        const { selectedInExList } = this.state;
        const text = data.value
        // const country = data.countryName ? data.countryName : '';
        // const states = data.stateName ? data.stateName : '';
        // const city = data.cityName ? data.cityName : ''
        const typeGeo = data.type;
        // const city = data.
        const geoType = data.type
        const isExist = selectedInExList.findIndex(item => data.key == item.catGeoId);

        if (isExist !== -1) {
            selectedInExList.splice(isExist, 1);
            if (e.target.nextElementSibling) e.target.nextElementSibling.style.color = '#808080';
            if (e.target.previousElementSibling) e.target.previousElementSibling.style.color = '#808080';
        }
        selectedInExList.push({ catGeoId: parseInt(data.key), geoValue: text, getoType: geoType, inEx });
        // selectedInExList.push(data);
        e.target.style.color = !!inEx ? 'rgb(0, 128, 0)' : 'rgb(255, 0, 0)';
    };

    handleSave = async () => {
        const { form, competitors, ages, getAgepayloadFormat, getGenderFormat, getPayloadGeoLocation, platforms,facebookAccountsData, getPayloadFacebookLocation } = this.state;
        let displayPlatformData = [
            { key: '1', value: 'Google Adwords', checked: true, disabled: false, parentIndex: null },
            { key: '2', value: 'Facebook', checked: true, disabled: false, parentIndex: null },
            { key: '3', value: 'Programmatic (ION & DV360)', checked: true, disabled: false, parentIndex: 1 },
        ]

       
        let displayPLayCheckDataPLatform = displayPlatformData.filter((dataPlat)=>dataPlat.checked).map((dataPlat)=>dataPlat.value);
        // const { match , history} = this.props
        let removeValiddationCompetetier = competitors.map((data) => {
            return {
                url: data.url,
                name: data.name
            }
        });

        let payload = {
            MediaPlan: {
                name: form.mediaPlanName,
                brandName: form.brandName,
                accountId: displayPLayCheckDataPLatform.includes('Facebook') ?facebookAccountsData && facebookAccountsData.length && facebookAccountsData[0]['id'] : '',
                category: form.campaigncategory,
                subCategory: form.subCampaigncategory,
                objective: form.campaignObjective,
                gender: form.gender,
                landingUrl: form.landingPageUrl,
                adType: this.state.adType,
                competetors: removeValiddationCompetetier,
                platforms: displayPLayCheckDataPLatform,
                baseCurrency:"USD",
                budget:form.budget,
                language:form.language,
                targeting: {
                    age: getAgepayloadFormat,
                    gender: getGenderFormat,
                    location: {
                        google: getPayloadGeoLocation,
                        facebook: getPayloadFacebookLocation
                    },
                }
            }

        }

        // console.log("payload",payload)
        const {
        tenantId,
        authToken,
        userId,
        history,
        postMediaCreateAction,
        } = this.props;

        const {
        responseCode: { status = "", msg = '' },
        responseList,
        } = await postMediaCreateAction({
        tenantId,
        authToken,
        userId,
        payload,
        });

        if (status) {
        this.toast(status, msg);
        }
    }

    handleRoleCompetetiorError = () => {
        const { competitors } = this.state;
        let check = true;
        competitors.forEach((item) => {
            const { errors, valid } = handleError(item, roleCompetetierList);
            item.errors = errors;
            if (!check || !valid) {
                check = false;
            } else if (check && valid) {
                check = true;
            }
        });
        this.setState({ competitors });
        return check;
    };

    handleSubmit = async () => {
        const { form, competitors, getPayloadGeoLocation, getPayloadFacebookLocation , specificLocation} = this.state;

        const {tenantId} = this.props;

        let displayPlatformData = [
            { key: '1', value: 'Google Adwords', checked: true, disabled: false, parentIndex: null },
            { key: '2', value: 'Facebook', checked: true, disabled: false, parentIndex: null },
            { key: '3', value: 'Programmatic (ION & DV360)', checked: true, disabled: false, parentIndex: 1 },
        ]

        let displayPLayCheckDataPLatform = displayPlatformData.filter((dataPlat)=>dataPlat.checked).map((dataPlat)=>dataPlat.value);

        // console.log(displayPLayCheckDataPLatform);
        // console.log(specificLocation,"space")
        // if(specificLocation.includes('Facebook') ){

        //     formFields.accountID.required=true 
        // }else{

        //     formFields.accountID.required=false 
        // }

        let { errors, valid, } = handleError(form, formFields);
        // console.log("errors",errors)
        // console.log("valid",valid)
        let validFlagMulit = this.handleRoleCompetetiorError(form, roleCompetetierList);

        if (!valid)
        {
            this.setState({ enableToast: true, toastMsg: "All Fields are Required", toastStatus: "Fail",errors: errors, submited: true });
        }
        else if (displayPLayCheckDataPLatform.includes('Facebook') && getPayloadFacebookLocation.length == 0 && displayPLayCheckDataPLatform.includes('Google Adwords') && getPayloadGeoLocation.length == 0) {
            this.setState({ enableToast: true, confirmationMsg: "Please select a Location", toastMsg: "", toastStatus: "required",submited: true });
        }

        else if (displayPLayCheckDataPLatform.includes('Facebook') && getPayloadFacebookLocation.length == 0) {
            this.setState({ enableToast: true, confirmationMsg: "Please select a Location for Facebook", toastMsg: "", toastStatus: "required",submited: true });
        }
        else if (displayPLayCheckDataPLatform.includes('Google Adwords') && getPayloadGeoLocation.length == 0) {
            this.setState({ enableToast: true, confirmationMsg: "Please select a Location for Google Adwords & Programmatic (ION & DV360)", toastMsg: "", toastStatus: "required",submited: true });
        }
        else if (displayPLayCheckDataPLatform.includes('Programmatic (ION & DV360)') && getPayloadGeoLocation.length == 0) {
            this.setState({ enableToast: true, confirmationMsg: "Please select a Location for Google Adwords & Programmatic (ION & DV360)", toastMsg: "", toastStatus: "required",submited: true });
        } else  if (valid && validFlagMulit) {
            if(demoTenantIds.includes(tenantId)){
                // return;
                this.setState({ enableToast: true, confirmationMsg: "You don't have permission for this module", toastMsg: "", toastStatus: "required" });
            }
            else{
             this.setState({ enableToast: true, confirmationMsg: "Are you sure you want to save?", toastMsg: "", toastStatus: "" });
            }
        }
        else {
            this.setState({ enableToast: true, toastMsg: "All Fields are Required", toastStatus: "Fail",errors: errors, submited: true });
            // this.setState({ errors: errors, submited: true });
            
        }
        
    }

    handleCheckboxChangeGroup = (e) => {
        // ==== campaign select platform ========
        const { form } = this.state;
        let { value, name } = e.target;
        form[name] = value;
        this.setState({ form });
        // console.log("form.platform",form.platform)

        if (form.platform != undefined && form.platform.length > 0) {
            // ===== specific location for platforms start's here ======
            var concatPlatform = [];
            form.platform.forEach((item, index) => {
                let curObj = form.platform[index];
                let parentObj = form.platform.find(obj => obj.key == curObj.parentIndex);
                if (item.checked) {
                    if (parentObj && parentObj.checked) {
                        let index = concatPlatform.findIndex(record => record == parentObj.value);
                        if (index > -1) {
                            concatPlatform.splice(index, 1);
                        }
                        let platformStr = parentObj.value + " & " + curObj.value
                        concatPlatform.push(platformStr);
                    } else {
                        concatPlatform.push(curObj.value);
                    }
                }
            })

            // ===== specific location for platforms end's here =====

            const platformsFilter = form.platform.filter(item => item.checked === true);
            var platforms = [];
            platformsFilter.forEach(ele => {
                platforms.push(ele.value);
            })

            // console.log("concatPlatform", concatPlatform);
            this.setState({ seletedPlatform: platforms, specificLocation: concatPlatform }, () => {
                platforms.forEach(item => {
                    if ((item == "TikTok") && (form.goaltype != "")) {
                        this.enableTiktokLocation();
                    }
                })
            })
        }


    }

    toast = (status, msg) => {
        this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
    }

    confirmationCallbackModel = (id) => {
        this.setState({ enableToast: false }, () => {
            this.handleSave();
        });

    }

    handleToastStatus = (status) => {
        const { match, history } = this.props;
        this.setState({ enableToast: status });
    }

    handleOnApplyGeo = () => {
        // const { openLocation, selectedFacebookGeoList, selectedGoogleGeoList } = this.state;
        // let locationGooglePayload = selectedGoogleGeoList.map((e) => {
        //     // console.log(e,"data")
        //     return {
        //         value: e.value,
        //         type: e.type,
        //         inex: e.inex,
        //         id: e.id

        //     }
        // })


        // let locationFacebookPayload = selectedFacebookGeoList.map((e) => {
        //     // console.log(e,"data")
        //     return {
        //         key: e.id,
        //         name: e.value,
        //         type: e.type,
        //         country_code: e.country_code,
        //         country_name: e.country_name,
        //         region: e.region,
        //         region_id: e.region_id,
        //         primary_city_id: e.primary_city_id,
        //         is_worldwide: e.is_worldwide,
        //         supports_region: e.supports_region,
        //         supports_city: e.supports_city,
        //         inex: e.inex

        //     }
        // })

        const { openLocation, tmpselectedFacebookGeoList, tmpselectedGoogleGeoList } = this.state;
        let locationGooglePayload = tmpselectedGoogleGeoList.map((e) => {
            // console.log(e,"data")
            return {
                value: e.value,
                type: e.type,
                inex: e.inex,
                id: e.id

            }
        })


        let locationFacebookPayload = tmpselectedFacebookGeoList.map((e) => {
            // console.log(e,"data")
            return {
                key: e.id,
                name: e.value,
                type: e.type,
                country_code: e.country_code,
                country_name: e.country_name,
                region: e.region,
                region_id: e.region_id,
                primary_city_id: e.primary_city_id,
                is_worldwide: e.is_worldwide,
                supports_region: e.supports_region,
                supports_city: e.supports_city,
                inex: e.inex

            }
        })


        let clonedFbtmpFacebookList = _.cloneDeep(tmpselectedFacebookGeoList);
        let clonedGoogletmpGoogleList = _.cloneDeep(tmpselectedGoogleGeoList)
        this.setState({ openLocation: !openLocation, getPayloadGeoLocation: locationGooglePayload, getPayloadFacebookLocation: locationFacebookPayload, selectedFacebookGeoList: clonedFbtmpFacebookList, selectedGoogleGeoList: clonedGoogletmpGoogleList, tmpselectedFacebookGeoList: [], tmpselectedGoogleGeoList: [] });



        // this.setState({ getPayloadGeoLocation: locationGooglePayload, getPayloadFacebookLocation: locationFacebookPayload })
        // this.setState({ openLocation: !openLocation })
    }

    clearLocationData = () =>{
        const {googleSearchLocation,facebookSearchLocation} = this.state;
        if(facebookSearchLocation){
         this.setState({tmpselectedFacebookGeoList:[]})
        }
        if(googleSearchLocation){
          this.setState({tmpselectedGoogleGeoList:[]})
        }
      }
    

    render() {
        const {
            confirmationOpen,
            confirmationInfo,
            submited,
            errors,
            touched,
            form,
            editMode,
            openLocation,
            openBulkPincodeSearch,
            geoInput,
            adType,
            ages,
            categoryData,
            subCategoryData,
            geoApiCall,
            geoList,
            languageData,
            selectedGeoList,
            selectedDeviceList,
            googleSearchLocation,
            facebookSearchLocation,
            selectedGoogleGeoList,
            selectedFacebookGeoList,
            specificLocation,
            // displayPlatformData,
            enableToast,
            toastMsg,
            toastStatus,
            confirmationMsg,
            facebookAccountsData,
            selectedGeoPlatForm,
            confirmationRemove,
            RemoveCompetitors,
            enableDeleteToast,
            tmpselectedGoogleGeoList,
            tmpselectedFacebookGeoList,
            getPayloadGeoLocation,
            getPayloadFacebookLocation

        } = this.state;

        let displayPlatformData = [
            {
                "key": "1",
                "value": "Google Adwords",
                "checked": true,
                "disabled": false,
                "parentIndex": null
            },
            {
                "key": "2",
                "value": "Facebook",
                "checked": true,
                "disabled": false,
                "parentIndex": null
            },
            {
                "key": "3",
                "value": "Programmatic (ION & DV360)",
                "checked": true,
                "disabled": false,
                "parentIndex": 1
            }
        ]
        let includedGeoList = [];
        let excludedGeoList = [];
        let includedGoogleGeoList = [];
        let excludedGoogleGeoList = [];
        let includedFacbookGeoList = [];
        let excludedFacbookGeoList = [];

        includedGoogleGeoList = (selectedGoogleGeoList || []).filter(item => !!item.inex);
        excludedGoogleGeoList = (selectedGoogleGeoList || []).filter(item => !item.inex);

        includedFacbookGeoList = (selectedFacebookGeoList || []).filter(item => !!item.inex);
        excludedFacbookGeoList = (selectedFacebookGeoList || []).filter(item => !item.inex);

        if (googleSearchLocation) {
            // includedGeoList = (selectedGoogleGeoList || []).filter(item => !!item.inex);
            // excludedGeoList = (selectedGoogleGeoList || []).filter(item => !item.inex);
            includedGeoList = (tmpselectedGoogleGeoList || []).filter(item => !!item.inex);
            excludedGeoList = (tmpselectedGoogleGeoList || []).filter(item => !item.inex);

        }
        else if (facebookSearchLocation) {
            // includedGeoList = (selectedFacebookGeoList || []).filter(item => !!item.inex);
            // excludedGeoList = (selectedFacebookGeoList || []).filter(item => !item.inex);
            includedGeoList = (tmpselectedFacebookGeoList || []).filter(item => !!item.inex);
            excludedGeoList = (tmpselectedFacebookGeoList || []).filter(item => !item.inex);
        }

        let displayPLayCheckDataPLatform = displayPlatformData.filter((dataPLat)=>dataPLat.checked).map((dataPlat)=>dataPlat.value);


        let showCombinePlat = [];
        let selPlatform =''
        if(displayPLayCheckDataPLatform.includes('Google Adwords')){
            showCombinePlat.push('Google Adwords');
        }
        if(displayPLayCheckDataPLatform.includes('Programmatic (ION & DV360)')){
            showCombinePlat.push('Programmatic (ION & DV360)');

        }
         displayPLayCheckDataPLatform.forEach((dataPlat)=>{
            if(!dataPlat.includes('Google Adwords') && !dataPlat.includes('Programmatic (ION & DV360)')){
                showCombinePlat.push(dataPlat);
            }
          
        })
        if(displayPLayCheckDataPLatform.includes('Google Adwords') && displayPLayCheckDataPLatform.includes('Programmatic (ION & DV360)')){
            showCombinePlat.push('Google Adwords & Programmatic (ION & DV360)');
            showCombinePlat =showCombinePlat.filter(ele=> ele !== "Google Adwords")
            showCombinePlat =showCombinePlat.filter(ele=> ele !== "Programmatic (ION & DV360)")

        }
      
      
      

        if(showCombinePlat.includes('Google Adwords & Programmatic (ION & DV360)')){
            selPlatform = 'Google Adwords & Programmatic (ION & DV360)'
        }
        else if(showCombinePlat.includes('Google Adwords')){
            selPlatform = "Google Adwords"
        }
        else if(showCombinePlat.includes('Programmatic (ION & DV360)')){
            selPlatform = "Programmatic (ION & DV360)"
        }

        // let selPlatform = displayPLayCheckDataPLatform.includes('Google Adwords') ? "Google Adwords" :
        // displayPLayCheckDataPLatform.includes('Programmatic (ION & DV360)') ? "Programmatic (ION & DV360)" :
        // displayPLayCheckDataPLatform.includes('Google Adwords & Programmatic (ION & DV360)') ? "Google Adwords & Programmatic (ION & DV360)" : ""


        const selectedDevices = (selectedDeviceList || []);

        //  let setPlatformForSelectLocation = showCombinePlat.includes('Google Adwords') ? "Google Adwords" :
        //  showCombinePlat.includes('Programmatic (ION & DV360)') ? "Programmatic (ION & DV360)" :
        //  showCombinePlat.includes('Google Adwords & Programmatic (ION & DV360)') ? "Google Adwords & Programmatic (ION & DV360)" : showCombinePlat.includes('Facebook') ? "Facebook" : ''





        // if (formFields.password.type === 'password') {
        //     formFields.password.type = "text"
        // } else {
        //     formFields.password.type = "password"
        // }
        // return this.setState(formFields)


        const shouldMakeBorderRed =  submited && (getPayloadFacebookLocation.length == 0 || getPayloadGeoLocation.length == 0 )
        // console.log("shouldMakeBorderRed",shouldMakeBorderRed)



        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}

                {
                    enableToast && <ToastModal
                        enableToast={enableToast}
                        status={toastStatus}
                        msg={toastMsg}
                        path={routes.containers.mediaPlan}
                        idProps={this.props}
                        handleConfirmation={this.confirmationCallbackModel}
                        handleToastStatus={this.handleToastStatus}
                        confirmationMsg={confirmationMsg}
                    />
                }

                {
                    enableDeleteToast && <ToastModal
                        enableToast={enableDeleteToast}
                        status={toastStatus}
                        msg={toastMsg}
                        // path={routes.containers.mediaPlan}
                        idProps={this.props}
                        handleConfirmation={this.confirmationCallbackDelete}
                        handleToastStatus={this.handleToastDelete}
                        confirmationMsg={confirmationMsg}
                    />
                }

                <Modal open={openLocation} size={googleSearchLocation ? "large" : "large"}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Geography</h5>
                            <button type="button" onClick={() => this.setState({ openLocation: !openLocation })} className="close" data-dismiss="modal" aria-label="Close">
                                <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="justify-content-between row">
                                {/* <div className={googleSearchLocation ? `col-md-3` : "col-md-6"} style={{ borderRight: '2px solid' }}> */}
                                <div className={googleSearchLocation ? `col-md-12` : "col-md-12"} style={{ marginBottom: 10, display:"flex" }}>
                                    {
                                        showCombinePlat.map((platform, index) =>
                                            <button key={index} className={`${selectedGeoPlatForm == platform ? 'audienceBtnActive' :'audienceBtnInactive'} audienceBtn`} style={{width:167,marginRight:5}} onClick={() => this.handleSpecificLocation(platform,index)}>
                                                {platform}
                                            </button>
                                        )
                                    }
                                </div>
                                <div className="col-md-8 p-3 d-flex justify-content-center border">
                                    {
                                        (googleSearchLocation || facebookSearchLocation) ?

                                            <div className='w-100'>
                                                {!openBulkPincodeSearch ? <div className='align-items-center border-bottom border-primary d-flex justify-content-center mb-3 row mx-1'>
                                                    <div className='col-md-1 p-0'>
                                                        <i className='mdi mdi-search-web' style={{ fontSize: '30px', color: "#506ee4" }}></i>
                                                    </div>
                                                    <div className='col-md-10'>
                                                        <input type='text'
                                                            name='searchLocation'
                                                            value={geoInput}
                                                            className='form-control border-0'
                                                            placeholder={`Search location here ...`}
                                                            onChange={this.handleGeoApi.bind(this)}
                                                        />
                                                    </div>
                                                </div>
                                                    :
                                                    <div className='row'>
                                                        <div className='col-md-12 mb-3'>
                                                            <div className='my-4'><u><b>bulk add Postal Codes</b></u></div>
                                                            <div className='border-bottom-1 border-primary d-flex justify-content-between border-bottom'>
                                                                <textarea style={{ width: '95%', height: '15vh' }} className='border-0'></textarea>
                                                            </div>
                                                            <div className='mt-1' style={{ color: '#808080' }}>Enter a list of Postal Codes(400601), one item to a line</div>
                                                            <div className='d-flex justify-content-end mt-2'>
                                                                <button className="btn border-0 mr-3 p-0 text-primary" style={{ backgroundColor: "#ffffff" }}><b>Include</b></button>
                                                                <button className="btn border-0 mr-3 p-0 text-primary" style={{ backgroundColor: "#ffffff" }}><b>Exclude</b></button>
                                                                <button onClick={() => this.openBulkPincode(false)} className="btn border-0 mr-3 p-0" style={{ backgroundColor: "#ffffff" }}><b>Cancel</b></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    geoInput.length > 0 && geoApiCall &&
                                                    <div className='d-flex justify-content-center align-Items-center text-primary'>Loading...</div>
                                                }
                                                {!geoApiCall && (googleSearchLocation || facebookSearchLocation) && geoList.length > 0 ? <div className='border border-primary p-2'>
                                                    <div className='mb-1'><u><b>Regional Locations</b></u></div>
                                                    <div style={{ maxHeight: '25vh', overflowY: 'scroll' }}>
                                                        {geoList.map((item) => {
                                                            const included = includedGeoList.some((includedItem) => includedItem.value === item.value);
                                                            const excluded = excludedGeoList.some((excludedItem) => excludedItem.value === item.value);

                                                            return (
                                                                <div className='align-items-center d-flex justify-content-between my-2'>
                                                                    <div className='text-primary'><b>{item.value}</b></div>
                                                                    <div>
                                                                        <i className={`mdi mdi-check btn p-0 ${included ? 'text-success' : 'text-muted'}`} style={{ fontSize: "30px", backgroundColor: '#ffffff' }} onClick={(e) => this.handleSelectLocation(e, item, 1)}></i>
                                                                        <i className={`mdi mdi-cancel btn p-0 ${excluded ? 'text-danger' : 'text-muted'}`} style={{ fontSize: "30px", backgroundColor: '#ffffff' }} onClick={(e) => this.handleSelectLocation(e, item, 0)}></i>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}

                                                    </div>
                                                </div> : geoList.length === 0 && geoList.length > 0 && !geoApiCall &&
                                                <div className='d-flex justify-content-center align-Items-center text-primary'>No Location found</div>
                                                }
                                            </div>
                                            : <div className=' w-100'><h4>Please Select Platform</h4></div>
                                    }
                                </div>
                                <div className="col-md-4 pl-2 d-flex justify-content-center">
                                    <div className='w-100' style={{ display: "grid" }}>
                                        <div className='border border-primary p-2 w-100 mt3'>
                                            <div><u><b>Included Regions & Locations</b></u></div>
                                            <div style={{ maxHeight: '15vh', overflowY: 'scroll' }}>
                                                {
                                                    includedGeoList.map((item) => {
                                                        return (
                                                            <div className='align-items-center d-flex justify-content-between my-2'>
                                                                <div><p className='text-primary' style={{ fontSize: '12px' }}>{item.value}</p></div>
                                                                <div>
                                                                    <button type='button' className='btn p-0' style={{ backgroundColor: "#ffffff" }} onClick={this.removeGeoLocation.bind(this, item.id)}>
                                                                        <i className='mdi mdi-close-circle' style={{ fontSize: '22px', color: "#506ee4" }}></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                                {
                                                    includedGeoList.length === 0 && <div className='align-items-center d-flex justify-content-start my-2'>
                                                        <div className='text-primary'><p className='text-primary' style={{ fontSize: '12px' }} >{'No included location found'}</p></div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className='border border-primary p-2 w-100 mt-1'>
                                            <div><u><b>Excluded Regions & Locations</b></u></div>
                                            <div style={{ maxHeight: '15vh', overflowY: 'scroll' }}>
                                                {
                                                    excludedGeoList.map((item) => {
                                                        return (
                                                            <div className='align-items-center d-flex justify-content-between my-2'>
                                                                <div><p className='text-primary' style={{ fontSize: '12px' }}>{item.value}</p></div>
                                                                <div>
                                                                    <button type='button' className='btn p-0' style={{ backgroundColor: "#ffffff" }} onClick={this.removeGeoLocation.bind(this, item.id)}>
                                                                        <i className='mdi mdi-close-circle' style={{ fontSize: '22px', color: "#506ee4" }}></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                                {
                                                    excludedGeoList.length === 0 && <div className='align-items-center d-flex justify-content-start my-2'>
                                                        <div className='text-primary'><p className='text-primary' style={{ fontSize: '12px' }}>{'No excluded location found'}</p></div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {
                                            (googleSearchLocation || facebookSearchLocation) ?
                                                <div className='d-flex justify-content-end mt-2' style={{ alignSelf: "end", justifySelf: "flex-end" }} >
                                                    <button className="btn border-0 mr-3 p-0 text-primary" onClick={this.handleOnApplyGeo} style={{ backgroundColor: "#ffffff" }}><b>Apply</b></button>
                                                    <button className="btn border-0 mr-3 p-0" style={{ backgroundColor: "#ffffff" }} onClick={() => this.clearLocationData()}><b>Clear</b></button>
                                                </div> : ""
                                        }

                                        {/* <div className='d-flex justify-content-end mt-2' style={{ alignSelf: "end", justifySelf: "flex-end" }} >
                                            <button className="btn border-0 mr-3 p-0 text-primary" onClick={this.handleOnApplyGeo} style={{ backgroundColor: "#ffffff" }}><b>Apply</b></button>
                                            <button className="btn border-0 mr-3 p-0" style={{ backgroundColor: "#ffffff" }} onClick={() => this.setState({ openLocation: !openLocation })}><b>Cancel</b></button>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <div className="main-panel ion add-margin-adj">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row justify-content-center mt-3">
                            <div className="col-md-12 grid-margin">
                                {/* <Card>
                                    <div className="float-right">
                                        <Link
                                            to={
                                                "/" +
                                                routes.mainRoute +
                                                "/" +
                                                routes.containers.mediaPlan
                                            }
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-primary">
                                                <i className="mdi mdi-keyboard-backspace"></i>Go back
                                            </button>
                                        </Link>
                                    </div>
                                </Card> */}
                                <Card>
                                    <div className='row mt-2'>
                                        <div className="margin-list-adj">
                                            <Link
                                                to={
                                                    "/" +
                                                    routes.mainRoute +
                                                    "/" +
                                                    routes.containers.mediaPlan
                                                }
                                            >
                                                <button
                                                    type="button"
                                                    className="btn btn-primary">
                                                    <i className="mdi mdi-keyboard-backspace"></i>Go back
                                                </button>
                                            </Link>
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.mediaPlanName.key]}
                                                setting={formFields[formFields.mediaPlanName.key]}
                                                error={errors[formFields.mediaPlanName.key]}
                                                submited={submited}
                                                touched={touched[formFields.mediaPlanName.key]}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.brandName.key]}
                                                setting={formFields[formFields.brandName.key]}
                                                error={errors[formFields.brandName.key]}
                                                submited={submited}
                                                touched={touched[formFields.brandName.key]}
                                            />
                                        </div>
                                        <div className="col-md-6 ">
                                            <Select
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.campaigncategory.key]}
                                                setting={formFields[formFields.campaigncategory.key]}
                                                error={errors[formFields.campaigncategory.key]}
                                                submited={submited}
                                                touched={touched[formFields.campaigncategory.key]}
                                                options={categoryData}
                                            />
                                        </div>
                                        <div className="col-md-6 ">
                                            <Select
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.subCampaigncategory.key]}
                                                setting={formFields[formFields.subCampaigncategory.key]}
                                                error={errors[formFields.subCampaigncategory.key]}
                                                submited={submited}
                                                touched={touched[formFields.subCampaigncategory.key]}
                                                options={subCategoryData}
                                            />
                                        </div>
                                        <div className="col-md-6 ">
                                            <MultiSelect
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.age.key]}
                                                setting={formFields[formFields.age.key]}
                                                error={errors[formFields.age.key]}
                                                submited={submited}
                                                touched={touched[formFields.age.key]}
                                                options={ages}
                                            />
                                        </div>
                                        <div className="col-md-6 ">
                                            <div className='custom-test-select mt-2'>
                                                <label>Gender <span className='text-danger'>*</span></label>
                                                <select name="gender" onChange={this.handleChange} value= {form.gender} className={errors.gender != undefined && errors.gender.required ? "has-error" : ""} onBlur={this.handleTouch}>
                                                    <option value="" disabled>--Select--</option>
                                                    {
                                                        GenderType.map(option =>
                                                            <option value={option.value}>{option.value}</option>
                                                        )
                                                    }
                                                </select>
                                                <span className='error-message'>{errors.gender != undefined && errors.gender.required ? "This field is required." : ""}</span>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                        <span style={{position: "absolute",top: 28,fontSize: 10}}className='text-primary'>Minimum budget allowed is 500 $</span>
                                            <Input
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.budget.key]}
                                                setting={formFields[formFields.budget.key]}
                                                error={errors[formFields.budget.key]}
                                                submited={submited}
                                                touched={touched[formFields.budget.key]}
                                            />
                                        </div>

                                        <div className="col-md-6 ">
                                            <SelectNew
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.language.key]}
                                                setting={formFields[formFields.language.key]}
                                                error={errors[formFields.language.key]}
                                                submited={submited}
                                                touched={touched[formFields.language.key]}
                                                options={languageData}
                                            />
                                        </div>


                                        <div className='col-md-12 mt-4 d-none'>
                                            <CheckboxGroup
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.adType.key]}
                                                setting={formFields[formFields.adType.key]}
                                                error={errors[formFields.adType.key]}
                                                submited={submited}
                                                allowClear={true}
                                                touched={touched[formFields.adType.key]}
                                                options={adTypesData}
                                            // options={form[formFields.platform.key]}
                                            // options={form[strategiesFormFields.deviceType.key]}
                                            />
                                        </div>

                                        <div className='col-md-12 d-none'>
                                            {
                                                displayPlatformData != undefined && displayPlatformData.length > 0 && (
                                                    // <div className='col-md-12'>
                                                    <CheckboxGroup
                                                        onChange={this.handleCheckboxChangeGroup}
                                                        onBlur={this.handleTouch}
                                                        value={form[formFields.platform.key]}
                                                        setting={formFields[formFields.platform.key]}
                                                        error={errors[formFields.platform.key]}
                                                        submited={submited}
                                                        allowClear={true}
                                                        touched={touched[formFields.platform.key]}
                                                        options={displayPlatformData}

                                                    />
                                                    // </div>
                                                )
                                            }




                                        </div>
                                        {/* <div className='col-md-12'>
                                            {
                                                displayPlatformData != undefined && displayPlatformData.length > 0 && (
                                                    // <div className='col-md-12'>
                                                    <CheckboxGroup
                                                        onChange={this.handleCheckboxChangeGroup}
                                                        onBlur={this.handleTouch}
                                                        value={form[formFields.platform.key]}
                                                        setting={formFields[formFields.platform.key]}
                                                        error={errors[formFields.platform.key]}
                                                        submited={submited}
                                                        allowClear={true}
                                                        touched={touched[formFields.platform.key]}
                                                        options={displayPlatformData}

                                                    />
                                                    // </div>
                                                )
                                            }




                                        </div> */}



                                        <div className="col-md-12 p-0 btn-block text-left mt-4 badgeText mb-4">
                                            <p style={{ fontSize: '14px' }}>Location</p>
                                        </div>
                                        {/* <div className="col-md-12"> */}



                                        
                                        {/* <div className='col-md-12 d-flex my-2'>
                                            <button className='btn btn-primary' onClick={this.selectLocation} disabled={displayPLayCheckDataPLatform.length == 0}> <i className="mdi mdi-search-web" style={{ fontSize: "20px", color: "#fff" }}></i>Click here to select Location</button>
                                        </div> */}
                                        <div className='col-md-12 d-flex my-2'>
                                        <button className={`btn btn-primary  ${shouldMakeBorderRed ? 'border border-danger' : ''}`} onClick={this.selectLocation} disabled={displayPLayCheckDataPLatform.length === 0}>
                                            <i className="mdi mdi-search-web" style={{ fontSize: "20px", color: "#fff" }}></i>Click here to select Location
                                        </button>
                                        </div>
                                        {/* {shouldMakeBorderRed ? <div><span class="error-message"><span>This field is required. </span></span></div> :''} */}
                                        {shouldMakeBorderRed ? (
                                        <div>
                                            {getPayloadFacebookLocation.length == 0 && getPayloadGeoLocation.length == 0 ? <div className="error-message">This field is required.</div> : null}
                                            {getPayloadFacebookLocation.length == 0 && getPayloadGeoLocation.length > 0 ? <div className="error-message">Location is required for Facebook.</div> : null}
                                            {getPayloadFacebookLocation.length > 0 && getPayloadGeoLocation.length == 0 ? <div className="error-message">Location is required for Google Adwords & Programmatic (ION & DV360).</div> : null}
                                        </div>
                                        ) : null}



                                        {/* {
                                            specificLocation.includes('Facebook') && <>
                                                <div className="col-md-6 ">
                                                    <div className='custom-test-select mt-2'>
                                                        <label>Facebook Accounts <span className='text-danger'>*</span></label>
                                                        <select name="accountID" onChange={this.handleChange}  className={errors.accountID != undefined && errors.accountID.required ? "has-error" : ""} onBlur={this.handleTouch}>
                                                            <option value="Select">--Select--</option>
                                                            {
                                                                facebookAccountsData.map(option =>
                                                                    <option value={option.text}>{option.text}</option>
                                                                )
                                                            }
                                                        </select>
                                                        <span className='error-message'>{errors.accountID != undefined && errors.accountID.required ? "This field is required." : ""}</span>
                                                    </div>
                                                </div>

                                            </>
                                        } */}




                                     {
                                        selectedGoogleGeoList.length>0 ?

                                        
                                            selPlatform &&
                                            <>
                                                <label className='ml-3 mt-3'>{selPlatform}</label>
                                                <div className='row px-4' style={{ justifyContent: 'space-between' }}>
                                                    <div className='col-md-6 col-12 mt-3 pl-0'>
                                                        <div class="card" style={{ height: "100%" }}>
                                                            <div class="card-body d-flex justify-content-start align-items-center">
                                                                <div class="card-icon pr-3 me-3">
                                                                    <span class="badge bg-label-success rounded-pill p-2">
                                                                        <i class="ti ti-check ti-sm"></i>
                                                                    </span>
                                                                </div>
                                                                <div class="card-title mb-0">
                                                                    <h5 class="mb-0 me-2">Included Regions{' & '}Locations:</h5>
                                                                    <small> {
                                                                        includedGoogleGeoList.map((item) => {
                                                                            return (
                                                                                <div><p className='text-primary' style={{ fontSize: '12px' }}>{item.value + ' - ' + item.type}</p></div>

                                                                            );
                                                                        })
                                                                    }
                                                                        {
                                                                            includedGoogleGeoList.length === 0 && <div><a href='javascript:void(0)'>{'No included location found'}</a></div>
                                                                        }</small>
                                                                </div>

                                                            </div>
                                                        </div>



                                                    </div>
                                                    <div className='col-md-6 col-12 mt-3 pr-0' >
                                                        <div class="card" style={{ height: "100%" }}>
                                                            <div class="card-body d-flex justify-content-start align-items-center">
                                                                <div class="card-icon pr-3 me-3">
                                                                    <span class="badge bg-label-danger rounded-pill p-2">
                                                                        <i class="ti ti-ban ti-sm"></i>
                                                                    </span>
                                                                </div>
                                                                <div class="card-title mb-0">
                                                                    <h5 class="mb-0 me-2">Excluded Regions{' & '}Locations:</h5>
                                                                    <small> {
                                                                        excludedGoogleGeoList.map((item) => {
                                                                            return (
                                                                                // <div><a href='javascript:void(0)'>{item.geoValue + ' - ' + item.getoType}</a></div>
                                                                                <div><p className='text-primary' style={{ fontSize: '12px' }}>{item.value + ' - ' + item.type}</p></div>

                                                                            );
                                                                        })
                                                                    }
                                                                        {
                                                                            excludedGoogleGeoList.length === 0 && <div><a href='javascript:void(0)'>{'No excluded location found'}</a></div>
                                                                        }</small>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        :''
                                     }
                                     {
                                        selectedFacebookGeoList.length >0 ?
                                        displayPLayCheckDataPLatform.includes('Facebook') &&
                                        <>
                                            <label className='mt-3 ml-3'>Facebook Location</label>
                                            <div className='row px-4' style={{ justifyContent: 'space-between' }}>

                                                <div className='col-md-6 col-12 mt-3 pl-0'>
                                                    <div class="card" style={{ height: "100%" }}>
                                                        <div class="card-body d-flex justify-content-start align-items-center">
                                                            <div class="card-icon pr-3 me-3">
                                                                <span class="badge bg-label-success rounded-pill p-2">
                                                                    <i class="ti ti-check ti-sm"></i>
                                                                </span>
                                                            </div>
                                                            <div class="card-title mb-0">
                                                                <h5 class="mb-0 me-2">Included Regions{' & '}Locations:</h5>
                                                                <small> {
                                                                    includedFacbookGeoList.map((item) => {
                                                                        // console.log(item,"iiiiiiii")
                                                                        return (
                                                                            // <div><a href='javascript:void(0)'>{item.geoValue + ' - ' + item.getoType}</a></div>
                                                                            <div><p className='text-primary' style={{ fontSize: '12px' }}>{item.value + ' - ' + item.type}</p></div>

                                                                        );
                                                                    })
                                                                }
                                                                    {
                                                                        includedFacbookGeoList.length === 0 && <div><a href='javascript:void(0)'>{'No included location found'}</a></div>
                                                                    }</small>
                                                            </div>

                                                        </div>
                                                    </div>



                                                </div>
                                                <div className='col-md-6 col-12 mt-3 pr-0' >
                                                    {/* <div className="col-sm-2"></div> */}


                                                    <div class="card" style={{ height: "100%" }}>
                                                        <div class="card-body d-flex justify-content-start align-items-center">
                                                            <div class="card-icon pr-3 me-3">
                                                                <span class="badge bg-label-danger rounded-pill p-2">
                                                                    <i class="ti ti-ban ti-sm"></i>
                                                                </span>
                                                            </div>
                                                            <div class="card-title mb-0">
                                                                <h5 class="mb-0 me-2">Excluded Regions{' & '}Locations:</h5>
                                                                <small> {
                                                                    excludedFacbookGeoList.map((item) => {
                                                                        return (
                                                                            // <div><a href='javascript:void(0)'>{item.geoValue + ' - ' + item.getoType}</a></div>
                                                                            <div><p className='text-primary' style={{ fontSize: '12px' }}>{item.value + ' - ' + item.type}</p></div>

                                                                        );
                                                                    })
                                                                }
                                                                    {
                                                                        excludedFacbookGeoList.length === 0 && <div><a href='javascript:void(0)'>{'No excluded location found'}</a></div>
                                                                    }</small>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    :''
                                     }

                                    




                                        {/* <div className='col-md-12 d-flex flex-column-mobile' style={{ justifyContent: 'space-between' }}>

                                            <div className='col-md-6 mt-3 p-2' style={{ border: '1px solid #80808030', borderRadius: '5px',boxShadow:"0 0.25rem 1.125rem rgba(75, 70, 92, 0.1)" }}>
                                                <div>
                                                    <div className='align-items-center ml-4'>
                                                        <i className="mdi mdi-check" style={{ fontSize: "30px", color: "#008000" }}></i>
                                                        {'   '}<span className='menu-title'><u><b>Included Regions{' & '}Locations:</b></u></span>
                                                    </div>
                                                    <div className='pl-5'>
                                                        {
                                                            includedGeoList.map((item) => {
                                                                // console.log(item,"iiiiiiii")
                                                                return (
                                                                    <div><a href='javascript:void(0)'>{item.geoValue + ' - ' + item.type}</a></div>
                                                                );
                                                            })
                                                        }
                                                        {
                                                            includedGeoList.length === 0 && <div><a href='javascript:void(0)'>{'No included location found'}</a></div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-6 mt-3 p-2' style={{ border: '1px solid #80808030', borderRadius: '5px',boxShadow:"0 0.25rem 1.125rem rgba(75, 70, 92, 0.1)" }}>
                                                <div className="col-sm-2"></div>
                                                <div>
                                                    <div className='align-items-center ml-5'>
                                                        <i className="mdi mdi-cancel" style={{ fontSize: "30px", color: "#FF0000" }}></i>
                                                        {'   '}<span className='menu-title'><u><b>Excluded Regions{' & '}Locations:</b></u></span>
                                                    </div>
                                                    <div className='pl-5'>
                                                        {
                                                            excludedGeoList.map((item) => {
                                                                return (
                                                                    <div><a href='javascript:void(0)'>{item.geoValue + ' - ' + item.type}</a></div>
                                                                );
                                                            })
                                                        }
                                                        {
                                                            excludedGeoList.length === 0 && <div><a href='javascript:void(0)'>{'No excluded location found'}</a></div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                        {/* </div> */}

                                        {/* <div className="col-md-12 mt-4">
                                            <div className='custom-test-select mt-2'>
                                                <label>Campaign Objective<span className='text-danger'>*</span></label>
                                                <select name="campaignObjective" onChange={this.handleChange} className={errors.campaignObjective != undefined && errors.campaignObjective.required ? "has-error" : ""} onBlur={this.handleTouch}>
                                                    <option value="Select">--Select--</option>
                                                    {
                                                        campaignObjective.map(option =>
                                                            <option value={option.value}>{option.value}</option>
                                                        )
                                                    }
                                                </select>
                                                <span className='error-message'>{errors.campaignObjective != undefined && errors.campaignObjective.required ? "This field is required." : ""}</span>
                                            </div>
                                        </div> */}

                                        <div className="col-md-12 mt-4">
                                            <div className='custom-test-select mt-2'>
                                                <label>Campaign Objective<span className='text-danger'>*</span></label>
                                                <select name="campaignObjective" onChange={this.handleChange} defaultValue={campaignObjective[0].value} className={errors.campaignObjective != undefined && errors.campaignObjective.required ? "has-error" : ""} onBlur={this.handleTouch}>
                                                <option disabled value="Select">--Select--</option>
                                                    {
                                                        campaignObjective.map(option =>
                                                            <option key={option.value} value={option.value}>{option.value}</option>
                                                        )
                                                    }
                                                </select>
                                                <span className='error-message'>{errors.campaignObjective != undefined && errors.campaignObjective.required ? "This field is required." : ""}</span>
                                            </div>
                                        </div>

                                        <div className="col-md-12 mt-2">
                                            <Input
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.landingPageUrl.key]}
                                                setting={formFields[formFields.landingPageUrl.key]}
                                                error={errors[formFields.landingPageUrl.key]}
                                                submited={submited}
                                                touched={touched[formFields.landingPageUrl.key]}
                                            />
                                        </div>



                                        <div className="col-md-12 p-0 btn-block text-left mt-4 badgeText">
                                            <p style={{ fontSize: '14px' }}>Competitors</p>
                                        </div>
                                        {/* </div> */}

                                        <this.renderCompetitors />
                                        <div className='d-flex justify-content-end mt-4'>
                                            <button className='btn btn-primary' style={{ backgroundColor: '#7367f0' }}
                                                onClick={() => this.handleAddClick()}
                                            ><i className="mdi mdi-plus"></i> Add Competitors </button>
                                        </div>
                                        {/* </div> */}

                                        <div className="form-group row mt-5" style={{ width: "100%" }}>
                                            <div className="col-sm-12">
                                                <center>
                                                    <button type="submit" onClick={() => this.handleSubmit()} className="btn btn-primary">Save</button>
                                                    {' '}
                                                    {/* <button type="button" onClick={() => { this.setState({ form: this.reset() }); }} className="btn btn-secondary">Reset</button> */}
                                                    {' '}
                                                    <Link to={'/' + routes.mainRoute + '/' + routes.containers.mediaPlan}><button type="button" className="btn btn-secondary">Cancel</button></Link>
                                                </center>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default connect(
    state => ({
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getAgeListAction,
        getCategoryAction,
        getSUbCategoryAction,
        postMediaCreateAction,
        getGeoLocationAction,
        getFacebookAccountsAction,
        getGeoLocationFacebookAction,
        getLanguageListAction

    }
)(index);


